<!--
 * @Description: 关联机构dialog
 * @Author: gaohc
 * @Date: 2022-09-05 16:43:52
-->
<template>
  <div>
    <el-dialog class="affiliate-ins-dialog" width="580px" title="关联机构" :visible.sync="visible"
      :close-on-click-modal="false" @open="initData" :before-close="handleCancel" center>
      <div class="dialog-body">
        <el-form ref="form" class="hsp-form" label-width="120px">
          <el-form-item required label="医院名称：">
            <el-input size="small" style="width: 310px" disabled v-model="hospitalData.name">
						</el-input>
          </el-form-item>
          <el-form-item label="服务机构：" required>
            <el-select size="small" @change="handleAffiliateInsChange" style="width: 310px"
              placeholder="请输入/选择" clearable v-model="instData.id" filterable value-key="id"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'bindingInst',
								srcBindingInst, this))"
              @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
								'bindingInst', srcBindingInst, this)">
              <el-option v-for="item in bindingInst" :key="item.id" :value="item.id"
                :label="item.status ? item.name : item.name + '（禁用）'"
                :disabled="item.status == 0 ? true : false">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="header">
          <span class="vertical-divider"></span>
          <span class="hsp-msg-title">医院信息</span>
        </div>
        <div class="content" :class="instData.id ? 'content-border' : ''">
          <el-image class="hspLogo" :src="loadHspLogo(hospitalData.logoPath)">
		  </el-image>
          <div class="hsp-msg-wrap">
            <div class="hsp-name">
			  			{{ hospitalData.name }}
						</div>
            <div>
			  			{{ hospitalData.city }}/{{ hospitalData.county }}
						</div>
            <div>
			  			{{ hospitalData.addr ? hospitalData.addr : "- -" }}
						</div>
          </div>
          <div v-if="instData.id" :class="showIsAffiateInst ? 'already-affiliate-wrap' : ''"
            class="affiliate-btn-wrap" @click="handleAffiliateIns">
            <el-image v-if="!showIsAffiateInst" style="width: 18px; height: 18px" :src="iconSrc">
						</el-image>
            <span>
			  			{{ showIsAffiateInst ? "已关联" : "关联" }}
						</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";

export default {
  name: "AffiliatedInstitutions",
  props: ["visible", "mode", "hspId"],
  data() {
    return {
      iconSrc: require("@/assets/hspmng/icon-hspmng-affiliate-ins.png"),
      bindingInst: [],
      hospitalData: {},
      instData: {}, //选择的机构信息
      showIsAffiateInst: false, //是否已关联
    };
  },
  computed: {
    loadHspLogo() {
      return (logoPath) => {
        return logoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, logoPath)
          : require("@/assets/instmng/instlist/img-instmng-default.png");
      };
    }
  },

  methods: {
    handleAffiliateInsChange(val) {
      if (!val) this.instData.id = null;

      this.$forceUpdate();   //强制input更新获取新值
      this.instData = Util.searchKeyWithValueInArr("id", val, this.bindingInst);
      if (this.instData.id) this.queryHasbindingInstitution();
    },

    //查询选择的机构是否已经被绑定
    queryHasbindingInstitution() {
      let params = {
        hspId: this.hspId, 
        instId: this.instData.id
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_HAS_BINDING_INSTITUTION,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        this.showIsAffiateInst = result.data;
      });
    },

	// 关联机构操作
    handleAffiliateIns() {
      if (this.showIsAffiateInst) return;
      this.$confirm(
        "请确保关联医院为" + this.instData.name + "的签约医院，请谨慎操作！", "确认关联机构吗",{
          confirmButtonText: "确认关联",
          customClass: "message-box",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.handelBindInst();
        });
    },

    handelBindInst() {
      let params = {
        hospitalId: this.hospitalData.id,
        institutionId: this.instData.id
      };
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_BINDING_INSTITUTION,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };

      this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.$message({
            type: "success",
            message: "关联成功!",
          });
          this.queryHasbindingInstitution(this.instData);
          this.$emit("close-dialog", true);
        });
    },

    initData() {
      this.getBindingInstDo();
    },

    getBindingInstDo() {
      let params = {id: this.hspId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_HOSPITAL_DO4BINDING_INST,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        this.hospitalData = result.data.hospital;
        this.bindingInst = result.data.simpleInstitutionList;
        this.srcBindingInst = result.data.simpleInstitutionList;
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.instData = {};
    }
  },
};
</script>

<style scoped>
.affiliate-ins-dialog .header {
  padding-left: 30px;
  padding-top: 20px;
  display: flex;
  align-items: center;
}

.affiliate-ins-dialog .vertical-divider {
  display: inline-block;
  width: 4px;
  height: 13px;
  background: #2a98ff;
  border-radius: 1px;
}

.affiliate-ins-dialog .hsp-msg-title {
  font-weight: 600;
  color: #000000;
  font-size: 15px;
  margin-left: 12px;
}

.affiliate-ins-dialog .content {
  margin: 25px 0 100px 30px;
  display: flex;
  align-items: center;
  border: 1px solid #eeeeee;
  padding-left: 12px;
  min-height: 109px;
}

.content-border {
  border-radius: 0px 6px 6px 0px;
}

.affiliate-ins-dialog .content .hspLogo {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.hsp-msg-wrap {
  flex: 1;
  padding-left: 20px;
  color: #666666;
  font-size: 13px;
}

.hsp-msg-wrap .hsp-name {
  color: #000000;
  font-size: 15px;
}

.hsp-msg-wrap div {
  margin-bottom: 6px;
}

.affiliate-btn-wrap {
  width: 96px;
  background: #c2d8fb;
  min-height: 109px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3e7ef5;
  cursor: pointer;
  border-radius: 0px 6px 6px 0px;
}

.already-affiliate-wrap {
  color: #333;
  background-color: #f1f1f1;
  cursor: default;
}

.affiliate-btn-wrap span {
  margin-left: 8px;
}

.hsp-form /deep/ .el-input.is-disabled .el-input__inner {
  color: #333333;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/hospitalList/AffiliatedInstitutions.vue